/** Pure luma diff for audience motion sampling — no Vite/env imports (safe under Jest). */
export function meanAbsLumaDiff(prev: Uint8Array, next: Uint8Array): number {
  let s = 0
  for (let i = 0; i < prev.length; i++) {
    s += Math.abs(prev[i] - next[i])
  }
  return (s / prev.length) / 255
}
